<template>
    <div class="top_con">
        <el-button type="primary" @click="back" style="margin-top:20px;">返回上一页</el-button>
        <el-table  ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange" :row-class-name="tableRowClassName" max-height="580px">
            <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
            <el-table-column  prop="reportname"  label="报告名称" show-overflow-tooltip></el-table-column>
            <el-table-column  prop="testingnum"  label="报告编号"></el-table-column>
            <el-table-column prop="typec_desc"  label="报告类型"></el-table-column>
            <el-table-column prop="testingtime"  label="检测时间"></el-table-column>
            <el-table-column prop="expiretime"  label="到期时间" show-overflow-tooltip></el-table-column>
            <el-table-column prop="beizhu"  label="备注" show-overflow-tooltip></el-table-column>
            <el-table-column label="操作" fixed="right" width="420">
                <template slot-scope="scope">
                    <el-link :underline="false" @click="look(scope.row.id)" style="margin-right:20px;">修改</el-link>
                     <el-link :underline="false" @click='dels(scope.row.id)' type="danger" style="margin-right:20px;">删除</el-link>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination  background layout="prev, pager, next"  :pager-count="5" :page-size="value" :total='total' @current-change="handleCurrentChange"></el-pagination>
        <div>
            <el-dialog :title="zp_tit" :visible.sync="dialogFormVisible" width="50%">
                <el-form :model="form"  label-width="100px">
                    <el-row :gutter="8">
                        <el-col :span="10">
                            <el-form-item label="报告名称"> 
                                <el-input v-model="form.reportname" placeholder="请输入" :disabled="tit_type==1?true:false"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="10">
                            <el-form-item label="报告类型">
                                <el-select v-model="form.typec_desc" placeholder="请选择" style="margin-right:20px;" @change="edit_type" :disabled="tit_type==1?true:false">
                                    <el-option label="设备检测报告" value="1"></el-option>
                                    <el-option label="防坠器检测报告" value="2"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="8">
                        <el-col :span="10">
                            <el-form-item label="检测时间">
                                <el-date-picker  v-model="form.testingtime" type="date" placeholder="选择月" value-format="yyyy-MM-dd"> </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="10">
                            <el-form-item label="检测报告编号">
                                <el-input v-model="form.testingnum" placeholder="请输入" :disabled="tit_type==1?true:false"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-col :span="10">
                        <el-form-item label="备注">
                            <el-input v-model="form.beizhu" placeholder="请输入" :disabled="tit_type==1?true:false"></el-input>
                        </el-form-item>
                    </el-col>
                </el-form>
                <div slot="footer" class="dialog-footer" >
                    <el-button type="primary" @click="editH" >确认修改</el-button>
                    <el-button @click="dialogFormVisible = false">取 消</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import {baogao_list,GetHousing,baogao_listXq,baogao_listEdit,baogao_listDel} from '@/utils/api'

export default {
    data(){
        return{
            user:{},
            formInline:{
                warehouse:'',
                conservator:'',
                tel:'',
            },
            houseLis:[],
            dialogFormVisible:false,
            zp_tit:"修改报告",
            tit_type:0,
            form:{},
            formLabelWidth: '120px',
            value:10,
            total:12,
            multipleSelection:[],
            tableData: [],
            pageNum:1,
            bgid:'',
        }
    },
    methods:{
        tableRowClassName({row,roeIndex}) {
            console.log(row.red)
            if (row.red === 1) {
            return 'warning-row';
            } 
            return '';
        },
        handleCurrentChange(val){
            let param ={
                numPerPage:this.value,
                pageNum:val,
                formInline:this.formInline
            }
            GetHousing(param).then(res=>{
                this.total=res.total,
                this.tableData=res.list
            });
        },
        open_bg(id){
            this.$router.push({
                path:'/BaoGao',
                query:{
                    id:id
                }
            })
        },
        look(id){
            this.dialogFormVisible=true
            this.tit_type=2;
            this.form={}
            this.edid=id;
            baogao_listXq({'id':id}).then(res=>{
                this.form=res;
            })
        },
        handleSelectionChange(val){
            this.multipleSelection = val;
        },
        edit_type(){
            this.form.typec=this.form.typec_desc
        },
        editH(){
            let param ={
                userId:this.user.uid,
                formInline:this.form,
                 id:this.edid
            }
            baogao_listEdit(param).then(res=>{
                this.dialogFormVisible=false;
                let params ={
                    numPerPage:this.value,
                    pageNum:this.pageNum,
                    sid:this.bgid,
                    id:this.listid
                }
                baogao_list(params).then(res=>{
                    this.total=res.total,
                    this.tableData=res.list
                })
            })
        },
        dels(id){
            this.$confirm('确定删除该条, 是否继续?', '删除', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    let param ={
                        userId:this.user.uid,
                        id:id
                    }
                    baogao_listDel(param).then(res=>{
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        let params ={
                            numPerPage:this.value,
                            pageNum:this.pageNum,
                            sid:this.bgid,
                            id:this.listid
                        }
                        baogao_list(params).then(res=>{
                            this.total=res.total,
                            this.tableData=res.list
                        })
                    });
                }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });
        },
        back(){
            this.$router.push({
                path:'/Warehouse',
                query:{
                    id:this.upid
                }
            })
        }
    },
    mounted(){
        this.user=JSON.parse(localStorage.getItem('userInfo'))
        this.bgid=this.$route.query.sid,
        this.listid=this.$route.query.id,
        this.upid=this.$route.query.upid
        let param ={
            numPerPage:this.value,
            pageNum:this.pageNum,
            sid:this.bgid,
            id:this.listid
        }
        baogao_list(param).then(res=>{
            this.total=res.total,
            this.tableData=res.list
        });
    },
}
</script>
<style>
    .top_con{
        width:100%;
        height:auto;
        padding:20px;
        box-sizing:border-box;
    }
    .el-form-item{
        vertical-align:middle;
        margin-right:20px;
    }
    .el-input{
        /* width:193px; */
        margin-right:10px;
    }
    .el-pagination {
        text-align: right;
        margin-top: 20px;
    }
    .el-table .warning-row{
        background:red;
        color:#000;
    }
</style>



// WEBPACK FOOTER //
// src/components/BaoGao.vue